export default __webpack_public_path__ + "static/media/Navaratri_1024.6ccd1a09.gif";